import { render, staticRenderFns } from "./Home-Footer.vue?vue&type=template&id=45fd6578&scoped=true&"
var script = {}
import style0 from "./Home-Footer.vue?vue&type=style&index=0&id=45fd6578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fd6578",
  null
  
)

export default component.exports